import React from 'react';
import { useRouter } from '../../providers/router/router-provider';
import { Spinner, SpinnerContent } from './style';

const LoadingSpinner = () => {
  const { loadingText } = useRouter();

  return (
    <SpinnerContent>
      <p>{loadingText}</p>
      <Spinner><div className='loader' /></Spinner>
    </SpinnerContent>
  );
};

export default LoadingSpinner;